module.exports = __webpack_public_path__ + "assets/img/alpha-kv-d7d108ad.jpg";